import React , { useEffect ,useState } from "react";
import "./AdminTools.css";

// Icons
import angleRightSolid from "../../assets/Icons/angle-right-solid.svg";
import penToSquare from "../../assets/Icons/penToSquare.svg";
import xmark from "../../assets/Icons/xmark.svg";
import deleteIcone from "../../assets/Icons/delete.svg";
import plusSolid from "../../assets/Icons/plusSolid.svg";
import { render } from "@testing-library/react";

import { socialDaata } from "../cv/imageContainer";
import { ChangedData } from "../../assets/ChangedData/ChangedData";
import { getDataCv } from "../../Screens/lebenslauf/Lebenslauf"

export var dataAllCv = "";
var dataToChange = ""




export const AdminToolCv = () =>{


    /* */   const [ socialAT , setSocialAT  ] = useState("");
    /* */   const [ TitelsAtool , setTitelsAtool  ] = useState("");
    


    useEffect(()=>{
        if (localStorage.getItem("isLogged") == "true") {
            let AdminTool = document.querySelector("#AdminTool");
            AdminTool.classList.remove("AdminToolZuu");
        }

        setTimeout(() => {
            let TargetIndex = 2;
            let NextElementIndex = TargetIndex++; 
            let myArray = [0 ,1, 2, 3, 4];
    
            let targetElemnt = myArray[TargetIndex],
                NextElement = myArray[NextElementIndex];
    
            myArray[NextElementIndex] =  targetElemnt;
            myArray[TargetIndex] =  NextElement;


        }, 1000);
    },[]);


    const renderAtSocial = (renderFrom) =>{
        const rend = renderFrom.map( (soc , i) => 
        <div className="mgcv15 d-flex justify-content-between align-items-center">  
            <img src={soc.logo} className="AtoolSocIcon" /> 
            <input placeholder={soc.link} type="text" className="addNewAMLInput addNewAMLInput2" /> 
            <img src={deleteIcone} onClick={removeSocila} className="AtoolSocIconDe" id={ `AtConnsmi_${i}` } />  
        </div> );
        setSocialAT(rend);
    }

    const ToolsZu = () => {
        let editIconAT = document.querySelector("#editIconAT");
        editIconAT.classList.toggle("editIconAT");

        let AdminTool = document.querySelector("#AdminTool");
        AdminTool.classList.toggle("AdminToolOpen");
    }

    const ToolSectionsHandel = (event) => {
        let welcheClass = event.target.getAttribute("ToolA");
        // Animations
        const allSectiosContainer =document.getElementById("allSectiosContainer");
        allSectiosContainer.classList.add("allSectiosContainerAus");
        const AdminToolSecessAnimations = document.getElementById(`${welcheClass}`);
        setTimeout(() => {
            allSectiosContainer.classList.add("allSectiosContainerAus2");
            AdminToolSecessAnimations.classList.remove(welcheClass);
        }, 220);

        // To Render
        renderAtSocial(socialDaata.socialmedia);
        let data = getDataCv();
        renderAllSectionsTitles(data);
    }

    const CloseToolSectionsHandel = (event) => {
        let welcheClass = event.target.getAttribute("ToolA");
        // Animations
        const AdminToolSecessAnimations = document.getElementById(welcheClass);
        AdminToolSecessAnimations.classList.add(welcheClass);
        
        const allSectiosContainer = document.getElementById("allSectiosContainer");
        allSectiosContainer.classList.remove("allSectiosContainerAus2");

        setTimeout(() => {
            allSectiosContainer.classList.remove("allSectiosContainerAus");
        }, 10);
    }

    const clickToEditAtUi = (event) => {
        var Uitarget = event.target.getAttribute("uitarget");
        document.getElementById(Uitarget).click();
        ToolsZu();
    }

    const onHoverTargetElement = (event) => {
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.add("targetToEditClass");
    }
    const onHoverOutTargetElement = (event) => {
        const target = event.target.getAttribute("uitarget");
        document.getElementById(target).classList.remove("targetToEditClass");
    }

    const openDropFContainer = () =>{
        const DropFileContainer = document.getElementById("DropFileContainer");
        DropFileContainer.classList.remove("DropFileContainerZu");

        const DropFileBG = document.getElementById("DropFileBG");
        const BodyVisableZu = document.getElementById("BodyVisableZu");

        setTimeout(() => {
            DropFileBG.classList.remove("DropFileBGZu");
        }, 10);

        setTimeout(() => {
            BodyVisableZu.classList.remove("BodyVisableZu");
        }, 300);
    }

    const removeSocila = (event) => {
        const index = event.target.id.match(/\d+/g);
        //__ Change Data
        const data = socialDaata;
        data.socialmedia.splice(index[0] , 1);
        renderAtSocial(data.socialmedia);
        if( !ChangedData["cvigCard"]) {
            ChangedData["cvigCard"] = data;
        }else{
            ChangedData["cvigCard"] = data;
        }
        //__ show save Changes
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    const addNewSocialContainer = () => {
        document.getElementById("AddnewSocial").classList.remove("AddnewSocialzu");
        
    }

    const addNewHandel = () => {

        const LinkInput = document.getElementById("newSocLinkInput");
        const obj = {
            "logo" : "https://oderasid.com/myWebSiteSRC/Icons/instaIcon.svg" ,
            "link" : ""
        }
        obj.link = LinkInput.value;
        //__ Change Data
        const data = socialDaata;
        data.socialmedia.push(obj);
        renderAtSocial(data.socialmedia);

        socialDaata.socialmedia = data.socialmedia;
        if( !ChangedData["cvigCard"]) {
            ChangedData["cvigCard"] = data;
        }else{
            ChangedData["cvigCard"] = data;
        }

        //__ show save Changes
        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    const renderAllSectionsTitles = (data) =>{
        const red = data.sec.map((title , index) =>
            <div className="elddr5tfff d-flex align-items-center">
                <div className="moveContainerTit d-flex flex-column justify-content-center">
                    <img src={angleRightSolid} className="MoveTopAT moveIconsAtol" id={`topMoveAto${index}`} onClick={moveUpATol} />
                    <img src={angleRightSolid} className="MoveBottomAT moveIconsAtol" id={`bottomMoveAto${index}`} onClick={moveDwonATol} />
                </div>
                <div className="elddr5tfff">
                    <div className="elcontr removeSectionCV d-flex justify-content-between align-items-center"> 
                        <div className="ssgttssweww" onClick={RemoveCVSection} onMouseOver={onHoverTargetElement} onMouseOut={onHoverOutTargetElement} uitarget={`cvhedite_${index}`} id={`cvhediteXid_${index}`} ></div> 
                        <p className="elementTitle elementTitleas"> { title.head.title } </p> 
                        <img className="penToSquare penToSquaresc" src={deleteIcone} /> 
                    </div>
                </div>
            </div>
        );
        setTitelsAtool(red);

        let datay = getDataCv();
        dataToChange = datay;
    }
 
    const RemoveCVSection = (event) =>{
        const id = event.target.id;
        let data = dataToChange;
        let index = id.match(/\d+/g);
        data.sec.splice(index[0] , 1);
        dataAllCv = data;

        renderAllSectionsTitles(data);

        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";


        if( !ChangedData["CVsections"]) {
            ChangedData["CVsections"] = data;
        }else{
            ChangedData["CVsections"] = data;
        }
    }

    const moveUpATol = (event) =>{
        let data = dataToChange;
        let id = event.target.id;

        let thisIndex = id.match(/\d+/g);
        thisIndex = Math.floor(thisIndex);
        let thisElement = data.sec[thisIndex];
        
        if (thisIndex){
            let NextIndex = thisIndex -1;
            let NextElement = data.sec[NextIndex];
            data.sec[NextIndex] = thisElement;
            data.sec[thisIndex] = NextElement;
            renderAllSectionsTitles(data);
        }
        dataAllCv = data;

        if( !ChangedData["CVsections"]) {
            ChangedData["CVsections"] = data;
        }else{
            ChangedData["CVsections"] = data;
        }

        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    const moveDwonATol = (event) =>{
        let data = dataToChange;
        let id = event.target.id;
        let thisIndex = id.match(/\d+/g);
        thisIndex = Math.floor(thisIndex);
        let thisElement = data.sec[thisIndex];
        let mylength = data.sec.length;

        if (thisIndex < mylength){
            let NextIndex = thisIndex +1;
            let NextElement = data.sec[NextIndex];
            data.sec[NextIndex] = thisElement;
            data.sec[thisIndex] = NextElement;
            renderAllSectionsTitles(data);
        }
        dataAllCv = data;

        if( !ChangedData["CVsections"]) {
            ChangedData["CVsections"] = data;
        }else{
            ChangedData["CVsections"] = data;
        }

        let SaveChangContainer = document.getElementById("SaveChangContainer");
        SaveChangContainer.style.visibility = "visible";
    }

    const OpenAddNewSecT = () => {
        const AddNewComponentCV = document.getElementById("AddNewComponentCV");
        AddNewComponentCV.classList.remove("AddNewComponentCVZu");
    }

    const AddNewSecHandel = () =>{
        const AddNewComponentCV = document.getElementById("AddNewComponentCV");
        AddNewComponentCV.classList.add("AddNewComponentCVZu");

        const titleOfAdNewSec = document.getElementById("titleOfAdNewSec");
        const SelectComponentTypeContainer = document.getElementById("SelectComponentTypeContainer");
        let title = titleOfAdNewSec.value;
        let type = SelectComponentTypeContainer.value;

        console.log(title);
        console.log(type);
        console.log(dataToChange);


        let data = dataToChange;
        let obj = {
            "sec": [
                {
                    "head":{
                        "title" : "About",
                        "logo" : "fas fa-user "
                    },
                    "Component" : "ABM" ,
                    "dat": {
                        "imgsrc": "" ,
                        "rws" : [
                            {
                                "key" : "Name:" ,
                                "value" : "Omar Shaar" ,
                                "icns" : "fas fa-user"
                            },
                            {
                                "key" : "Anschrift:" ,
                                "value" : "Deutschland, 53111 Bonn" ,
                                "icns" : "fas fa-map-marked-alt"
                            },
                            {
                                "key" : "Tel:" ,
                                "value" : "0176  / 42942588",
                                "icns" : "fas fa-phone"
                            },
                            {
                                "key" : "E-Mail:" ,
                                "value" : "contact@omarshaar.com",
                                "icns" : "fas fa-envelope" 
                            },
                            {
                                "key" : "geb. am:" ,
                                "value" : "01.01.1998 Ariha",
                                "icns" : "fas fa-birthday-cake"
                            }
                        ]
        
                    }
                },
                {
                    "head":{
                        "title" : "Ausbildung",
                        "logo" : "fas fa-briefcase "
                    },
                    "Component" : "AUSB" ,
                    "dat": [
                        {
                            "Date" : "2/2020 - 9/2020" ,
                            "value" : "Integrationskurs: Deutsche Wirtschaftsakademie in Bonn" ,
                            "key" : "Zertifikat: B1" 
                        },
                        {
                            "Date" : "8/2017 - 2/2018" ,
                            "value" : "Abendrealschule in Bonn" ,
                            "key" : "" 
                        },
                        {
                            "Date" : "1/2016 - 6/2016" ,
                            "value" : "Internationale Klasse des Friedrich-List-Berufskolleg in Bonn" ,
                            "key" : "" 
                        },
                        {
                            "Date" : "8/2012 - 6/2015" ,
                            "value" : "Gymnasium: Tikaniat Alhasob in Aleppo/Syrien" ,
                            "key" : "Abschluss: Fachhochschulreife Fachbereich Computertechnik" 
                        },
                        {
                            "Date" : "8/2007 - 6/2012" ,
                            "value" : "Mittelschule: Alsayadi in Ariha/Syrien" ,
                            "key" : "Abschluss: Mittlere Reife" 
                        },
                        {
                            "Date" : "8/2003 - 6/2007" ,
                            "value" : "Grundschule: BanatAriha in Ariha/Syrien" ,
                            "key" : "" 
                        }
                    ]
                },
                {
                    "head":{
                        "title" : "Praktika",
                        "logo" : "fas fa-gavel "
                    },
                    "Component" : "PRCT" ,
                    "dat": [
                        {
                            "Date" : "8/2021 - Heute" ,
                            "value" : "Telekom AG, Bonn" ,
                            "key" : "Einstiegsqualifizierungsjahr als IT-Systemelektroniker" 
                        },
                        {
                            "Date" : "5/2021 - 7/2021" ,
                            "value" : "Frenken & co." ,
                            "key" : "Datenerfasser im Impfzentrum in Teilzeit" 
                        },
                        {
                            "Date" : "12/2020 - 5/2021" ,
                            "value" : "Rewe Center, Rewe Markt GmbH, Bonn" ,
                            "key" : "Regalservice in Teilzeit" 
                        },
                        {
                            "Date" : "7/2013 -10/2013 - 7/2014 - 10/2014" ,
                            "value" : "Mobilfunkeinzelhandel Itisalat, Ariha" ,
                            "key" : "Verkäufer in Teilzeit" 
                        },
                        {
                            "Date" : "7/2009 - 10/2009" ,
                            "value" : "Tischlerei Abomoaheb, Aleppo" ,
                            "key" : "Praktikum als Tischler" 
                        }
                    ]
                },
                {
                    "head":{
                        "title" : "Kenntnisse",
                        "logo" : "fas fa-fill-drip "
                    },
                    "Component" : "KENTS" ,
                    "dat": [
                        {
                            "title" : "Computerrechnik" ,
                            "rows" : [
                                "10-Finger-System - Grundkenntnisse " ,
                                "Microsoft Office Paket (Word, Excel, Power Point) - Gute Kenntnisse" ,
                                "Adobe Programme (Photoshop, Illustrator, XD, InDesign) - Gute Kenntnisse" ,
                                "HTML / CSS - Sehr gute Kenntnisse" ,
                                "JavaScript, PHP - Gute Kenntnisse " , 
                                "Java - Grundkenntnisse" , 
                                "MySQL Datenbank - Gute Kenntnisse " 
                            ]
                        },
                        {
                            "title" : "Sprachkenntnisse" ,
                            "rows" : [
                                "Arabisch - Muttersprache" ,
                                "Deutsch - B1" ,
                                "Englisch -  A2 "
                            ]
                        }
                    ]
                }
            ]
        }

        switch (type) {
            case "ABM":
                obj.sec[0].head.title = title;
                data.sec.push(obj.sec[0]);
                break;
        
            default:
                break;
        }

        dataAllCv = data;
        if( !ChangedData["CVsections"]) {
            ChangedData["CVsections"] = data;
        }else{
            ChangedData["CVsections"] = data;
        }
        renderAllSectionsTitles(data);
        console.log(data);
    }



























    return(
        <div className="AdminTool AdminToolZuu AdminToolOpen" id="AdminTool">
        <div className="closeOpenSetting d-flex align-items-center justify-content-center"  onClick={ToolsZu}  >
            <i className="fas fa-cog editIconAT" id="editIconAT"></i>
        </div>

        <div className="ToolsAdmionMainContainer">
            <div className="mainHeaderAdminTool">
                <p className="TitleAdminPanel">Admin Panel</p>
            </div>

            <div className="ToolBody">

                <div className="allSectiosContainer" id="allSectiosContainer">
                    <p className="psecs">Page sections</p>
                    <div className="secsContainer">
                        <div className=" d-flex  justify-content-between align-items-center sescDivItem"> <div className="ssgttssweww" ToolA="AToolCvimgCard"  onClick={ToolSectionsHandel} id="sawwllksssaqseerwww"></div> <p className="SecsTitle">Image Card</p> <img src={angleRightSolid} className="angleRightSolid" /></div>
                        <div className=" d-flex  justify-content-between align-items-center sescDivItem"> <div className="ssgttssweww" ToolA="AToolcvSections"  onClick={ToolSectionsHandel} id="sawwllksssaqseerwww2"></div> <p className="SecsTitle">CV sections</p> <img src={angleRightSolid} className="angleRightSolid" /></div>
                    </div>
                </div>

                { /* ///////////////////////////////////     Image Card     //////////////////////////////////////// */ }
                <div className="AToolHomeMainContainer AToolCvimgCard" id="AToolCvimgCard" >
                    {/*  _____Header_____ */}
                    <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                        <p className="HTATool ">Edit image card</p>
                        <img src={xmark} className="xmarkIcon" ToolA="AToolCvimgCard" onClick={CloseToolSectionsHandel}/>
                    </div>

                    {/*  _____Body_____ */}
                    <div className="atoolsecBody">
                        <div className="d-flex justify-content-between align-items-center">  <p className="ATOOLKeysAMEcv" >My image</p>  <img src={plusSolid} onClick={openDropFContainer} className="deleteIcone"/>  </div>
                        <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={clickToEditAtUi} onMouseOver={onHoverTargetElement} onMouseOut={onHoverOutTargetElement} uitarget="Name"></div> <p className="elementTitle">My Name</p> <img className="penToSquare penToSquaresc" src={penToSquare} /> </div>
                        <div className="elcontr d-flex justify-content-between align-items-center"> <div className="ssgttssweww" onClick={clickToEditAtUi} onMouseOver={onHoverTargetElement} onMouseOut={onHoverOutTargetElement} uitarget="berf"></div> <p className="elementTitle">My Job</p> <img className="penToSquare penToSquaresc" src={penToSquare} /> </div>
                        <div className="socilamedEdiAT">
                            <div id="parentElementsocialAT">
                                <div className=" d-flex justify-content-between align-items-center "> <p className="elementTitle">My Socialmedia</p> <img src={plusSolid} className="deleteIcone" onClick={addNewSocialContainer}/> </div>
                                <div className="AddnewSocial AddnewSocialzu" id="AddnewSocial">
                                    <div className="addnisocHead">
                                        Add New Socialmedia
                                    </div>
                                    <div className="iconContainerAddNewSoc d-flex justify-content-between align-items-center" >
                                        <span>Add Icon</span>
                                        <img src={penToSquare} className="plusSolid" onClick={openDropFContainer}/>
                                    </div>
                                    <input type="text" placeholder="Add your Link here" className="addNewAMLInput addNwwffw" id="newSocLinkInput" />
                                    <div className="addbtn d-flex justify-content-center align-items-center" onClick={addNewHandel} id="addbtnATOOLsoc">Add</div>
                                </div>
                                { socialAT }
                            </div>
                        </div>
                    </div>
                </div>



                { /* ///////////////////////////////////     CV Sections     //////////////////////////////////////// */ }
                <div className="AToolHomeMainContainer AToolcvSections" id="AToolcvSections" >
                    {/*  _____Header_____ */}
                    <div className="sklskzsssssss  d-flex align-items-center justify-content-between">
                        <p className="HTATool">Edit cv sections</p>
                        <img src={xmark} className="xmarkIcon" ToolA="AToolcvSections" onClick={CloseToolSectionsHandel}/>
                    </div>

                    {/*  _____Body_____ */}
                    <div className="atoolsecBody">
                        <div className="AllmySectionsTitlesContainertAtooL">
                           { TitelsAtool }
                        </div>

                        <div className="AddNewmAINcONTAINERCV">
                            <div className="HeadAddNewmAINcONTAINERCV d-flex align-items-center justify-content-between">
                               <p className="AddNewSecLabel"> Add new Section </p>
                               <img src={plusSolid} className="xmarkIcon" ToolA="AToolcvSections" id="AddNewSecAT" onClick={OpenAddNewSecT} />
                            </div>
                            <div className="AddNewComponentCV AddNewComponentCVZu" id="AddNewComponentCV">
                                <input placeholder="Add Title" type="text" className="addNewAMLInput addNewAMLInput3"  id="titleOfAdNewSec"/> 

                                <select className="SelectComponentTypeContainer" id="SelectComponentTypeContainer">
                                    <option value="...">Select Component Type</option>
                                    <option value="ABM">About Component</option>
                                    <option value="AUSB">Ausbildung Component</option>
                                    <option value="PRCT">Praktika Component</option>
                                    <option value="KENTS">Kenntnisse Component</option>
                                </select>

                                <div className="addbtn d-flex justify-content-center align-items-center" onClick={AddNewSecHandel} id="AddNewSecHandelBtn">Add</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
    );
}